///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case = abcsetup.set_case || {};
abcsetup.set_case.orgs = abcsetup.set_case.orgs || {};
abcsetup.set_case.orgs.show = abcsetup.set_case.orgs.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.set_case.orgs.show = {
    init: function() {
        Livewire.on('policyAdded', function() {
            $('.policy-modal').modal('hide');
        })
    },
}